/** W-9 verification: business (EIN) filers upload the IRS EIN document — SS-4 confirmation or CP 575 notice. */
import React, { useState } from 'react';
import { toast } from 'sonner';
import api from '../../lib/api';
import { errorText } from '../finance/financeUi';

export function EinUpload({ tax, onDone }) {
  const [busy, setBusy] = useState(false);
  if (!tax) return null;
  const doc = tax.ein_document;
  const upload = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = '';
    if (!file) return;
    const fd = new FormData(); fd.append('file', file);
    setBusy(true);
    try { onDone(await api.request('/activation/tax/ein-document', { method: 'POST', body: fd })); toast.success('EIN document uploaded for MSC review'); } catch (err) { toast.error(errorText(err)); } finally { setBusy(false); }
  };
  return (
    <div className="mt-3 space-y-2 rounded-lg border bg-muted/30 p-3 text-sm" data-testid="ein-upload">
      <p className="font-medium">IRS EIN document (Form SS-4 confirmation or CP 575 notice){tax.ein_required ? <span className="text-red-600"> · required for business filers</span> : <span className="text-muted-foreground"> · optional</span>}</p>
      <p className="text-xs text-muted-foreground">MSC uses it to verify the business name and EIN on your W-9. PDF, PNG or JPG, up to 10 MB.</p>
      {doc && <p className="text-xs" data-testid="ein-upload-status">Uploaded {doc.filename} · {new Date(doc.uploaded_at).toLocaleString()} · <span className={`rounded-full px-2 py-0.5 font-medium ${{ APPROVED: 'bg-emerald-100 text-emerald-800', REJECTED: 'bg-red-100 text-red-800' }[doc.status] || 'bg-amber-100 text-amber-800'}`} data-testid="ein-status-pill">{{ PENDING_REVIEW: 'Awaiting MSC review', APPROVED: 'Approved by MSC', REJECTED: 'Rejected' }[doc.status] || doc.status}</span></p>}
      {doc?.status === 'REJECTED' && <p className="text-xs text-red-700" data-testid="ein-reject-reason">MSC's note: {doc.review_reason}. Please upload a new copy.</p>}
      {doc?.status !== 'APPROVED' && <label className={`inline-flex h-9 cursor-pointer items-center rounded-full border bg-white px-4 text-sm ${busy ? 'opacity-50' : 'hover:bg-muted'}`}>
        {busy ? 'Uploading…' : doc ? 'Replace document' : 'Upload SS-4 / EIN letter'}
        <input type="file" accept="application/pdf,image/png,image/jpeg" className="hidden" disabled={busy} onChange={upload} data-testid="ein-upload-input" />
      </label>}
    </div>
  );
}
